import { addCommasToNumber } from './BudgetGuidance'

interface BudgetBarChart {
  currencySymbol: string
  basicBudget: number
  averageBudget: number
  highEndBudget: number
}

const BudgetGuidanceBarChart = ({
  currencySymbol,
  basicBudget,
  averageBudget,
  highEndBudget,
}: BudgetBarChart): JSX.Element => {
  return (
    <div style={{ position: 'relative', marginTop: '24px' }}>
      <div
        style={{
          position: 'absolute',
          width: '100%',
          height: '100%',
        }}>
        <section
          className='BUDGET_GUIDANCE_BOX_POSITION'
          style={{ transform: 'translateX(-50%)', left: '50%' }}>
          <span style={{ fontSize: '16px', fontWeight: '500', color: '#262626' }}>Average</span>
          <section className='BUDGET_GUIDANCE_BOX'>
            <span className='BUDGET_GUIDANCE_TEXT'>
              {currencySymbol}
              {addCommasToNumber(averageBudget)}
            </span>
          </section>
        </section>
        <section
          className='BUDGET_GUIDANCE_BOX_POSITION'
          style={{ right: 'calc(50% + 32px)', top: '69px' }}>
          <span style={{ fontSize: '16px', fontWeight: '500', color: '#262626' }}>Basic</span>
          <section className='BUDGET_GUIDANCE_BOX'>
            <span className='BUDGET_GUIDANCE_TEXT'>
              {currencySymbol}
              {addCommasToNumber(basicBudget)}
            </span>
          </section>
        </section>
        <section
          className='BUDGET_GUIDANCE_BOX_POSITION'
          style={{ left: 'calc(50% + 30px)', top: '56px' }}>
          <span style={{ fontSize: '16px', fontWeight: '500', color: '#262626' }}>High-end</span>
          <section className='BUDGET_GUIDANCE_BOX'>
            <span className='BUDGET_GUIDANCE_TEXT'>
              {currencySymbol}
              {addCommasToNumber(highEndBudget)}
            </span>
          </section>
        </section>
      </div>
      <svg
        className='BUDGET_GUIDANCE_CHART'
        width='220'
        height='187'
        viewBox='0 0 220 187'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'>
        <g clipPath='url(#clip0_675_2414)'>
          <rect x='97.4287' y='60' width='24' height='126' rx='4' fill='#AF231C' />
          <rect x='65.2861' y='129' width='24' height='57' rx='4' fill='#C76560' />
          <rect x='33.2861' y='153' width='24' height='33' rx='4' fill='#EFD3D2' />
          <rect
            x='1.28613'
            y='171'
            width='24'
            height='16'
            rx='4'
            fill='#EFD3D2'
            fillOpacity='0.5'
          />
          <rect
            x='193.429'
            y='176'
            width='24'
            height='10'
            rx='4'
            fill='#EFD3D2'
            fillOpacity='0.5'
          />
          <rect x='161.429' y='141' width='24' height='45' rx='4' fill='#EFD3D2' />
          <rect x='129.429' y='116' width='24' height='70' rx='4' fill='#C76560' />
        </g>
        <defs>
          <clipPath id='clip0_675_2414'>
            <rect width='219' height='187' fill='white' transform='translate(0.428711)' />
          </clipPath>
        </defs>
      </svg>
    </div>
  )
}

export default BudgetGuidanceBarChart
